import React from "react";
import { Link } from "react-router-dom";
import { useLocalization } from "../hooks/useLocalization";
import { useAuth } from "../hooks/useAuth";
import { EagleState } from "../components/EagleState";

/** Top-level catch-all for any URL that matches no route in the app (typo'd deep link,
 * stale bookmark, removed page). Previously this silently bounced every unmatched path -
 * including ones typed by an already-authenticated management/employee user - all the way
 * out to the public marketing homepage via `<Navigate to="/" />`, which looked like a broken
 * link rather than a real 404. This keeps the user informed and gives them a safe way back
 * into whichever portal they were actually using. */
export default function NotFoundPage() {
  const { t } = useLocalization();
  const { user } = useAuth();
  const homeHref = user ? (user.active_portal === "STAFF" ? "/employee" : "/management") : "/";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50" data-testid="not-found-page">
      <div className="max-w-sm text-center">
        <EagleState
          variant="notfound"
          title={t("notFoundPage.title")}
          message={t("notFoundPage.message")}
          testId="not-found-eagle"
        />
        <Link
          to={homeHref}
          data-testid="not-found-home-link"
          className="inline-block px-5 py-2 rounded-full bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 active:scale-95 transition-all"
        >
          {user ? t("accessDeniedPage.goHome") : t("notFoundPage.goToSite")}
        </Link>
      </div>
    </div>
  );
}
